module.exports = __webpack_public_path__ + "static/media/gu.d0da25e7.svg";